module.exports = __webpack_public_path__ + "media/images/country_flags/united_nations-2fb8eab6c81bcb184daae5f069bf4579.png";